import React from 'react'
import { Link } from 'react-router-dom'

const Footer = ({ productsData, onScrollTo, contact = {}, copyrightYear }) => {
  const year = copyrightYear || new Date().getFullYear()
  const productsList = productsData
    ? Object.values(productsData)
    : [
        { id: 'chilli-powder', name: 'Chilli Powder' },
        { id: 'coriander-powder', name: 'Coriander Powder' },
        { id: 'turmeric-powder', name: 'Turmeric Powder' },
        { id: 'garam-masala', name: 'Garam Masala', comingSoon: true },
        { id: 'dried-spices', name: 'Dried Spices', comingSoon: true }
      ]

  const handleScroll = (id) => {
    if (onScrollTo) return onScrollTo(id)
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  }

  const email = contact.email || 'care@agniyaspices.com'
  const phone = contact.phone || '+91 8086 07 5558'
  const address = contact.address || '236/2, Convent Road, Lokamaleswaram, Kodungallur, Kerala, India'

  return (
    <footer className="bg-[#1e1919] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-bold text-[#8B2820] mb-4">AGNIYA SPICES</h3>
            <p className="text-[#bbb5ae]">Pure & Trusted in Every Pinch</p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Products</h4>
            <div className="space-y-2">
              {productsList.map((p) => (
                <Link
                  key={p.id}
                  to={p.id ? `/products/${p.id}` : '#'}
                  className="block text-[#bbb5ae] hover:text-[#8B2820] transition-colors text-sm"
                >
                  {p.name} {p.comingSoon && <span className="text-amber-500">(Launching Soon)</span>}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-[#bbb5ae] hover:text-[#8B2820] transition-colors">Home</Link>
              <button onClick={() => handleScroll('products')} className="block text-left text-[#bbb5ae] hover:text-[#8B2820] transition-colors">Products</button>
              <Link to="/testimonials" className="block text-[#bbb5ae] hover:text-[#8B2820] transition-colors">Testimonials</Link>
              <Link to="/spices-guide" className="block text-[#bbb5ae] hover:text-[#8B2820] transition-colors">Spices Guide</Link>
              <Link to="/faq" className="block text-[#bbb5ae] hover:text-[#8B2820] transition-colors">FAQ</Link>
              <button onClick={() => handleScroll('contact-form')} className="block text-left text-[#bbb5ae] hover:text-[#8B2820] transition-colors">Contact</button>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <div className="space-y-2 text-[#bbb5ae] text-sm">
              <p>{email}</p>
              <p>{phone}</p>
              <p>{address}</p>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-[#736c64] text-center text-[#bbb5ae]">
          <p>&copy; {year} Agniya Spices. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
